module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', [_vm._v(_vm._s(_vm.$t("brand.label")))]), _vm._v(" "), _c('p', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.$t("brand.help")))]), _vm._v(" "), (_vm.brands.length) ? _c('div', {
    staticClass: "brand-selector"
  }, [_c('div', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showDropdown = true
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.selectedBrand.logo,
      "alt": ((_vm.selectedBrand.name) + " logo")
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.selectedBrand.name))]), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-menu-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu-container"
  }, [_c('ul', {
    staticClass: "dropdown-menu",
    class: {
      'show': _vm.showDropdown
    }
  }, _vm._l((_vm.brands), function(brand) {
    return _c('li', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.selectBrand(brand)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": brand.logo,
        "alt": ((brand.name) + " logo")
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "brand-name"
    }, [_vm._v(_vm._s(brand.name))])])
  }), 0)])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80479a14"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/markerEdit/SelectBrand.vue
// module id = 1061
// module chunks = 1